import * as React from "react";
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { FRONTEND_ORIGIN_URL_NO_SLASH } from "../config";
import withTracker from "./withtracker";
import AuthorizationHOC from "./AuthorizationHOC";
import { ALL_USERS } from "../constants/userGroups";
import MetaData from "../components/meta/meta";
import { getRouteUrl } from "../routers";
import { ROUTE_PAGE_HOME } from "../routers/content/page";
import { parsefrontPageBanners } from "../constants/parse/banners";
import FrontPage from "../components/frontpage/frontpage";
import { setManuallLogout } from "../authentication/actions";
import { getUserIdFromState } from "../mappers/backendMappers";
import APIProductService from "../services/APIProductService";
import { parseApiProducts } from "../constants/parse/product";

function FrontPageHOC(props) {
  const {
    username,
    sampleAction,
    frontPageBanners,
    isLoggedIn,
    isManuallyLoggedOut,
    setManuallLogout,
    csrfToken,
    applicationUser,
  } = props;

  const [featuredApis, setFeaturedApis] = useState([]);

  // Hardcoded steps
  const hardcodedSteps = [
    {
      title: "GET ACCESS",
      description:
        "Sign up for an account, register an app, connect to an API.",
    },
    {
      title: "BUILD YOUR APP",
      description:
        "Use the sandbox to experiment, then code and test against the provided test data.",
    },
    {
      title: "GET SIGNED",
      description: "Request production access for your app and go live!",
    },
  ];

  useEffect(() => {
    const loadFeaturedApis = async () => {
      try {
        const userId = getUserIdFromState({ applicationUser });
        // Fetch featured products from service (raw data)
        const rawProducts = await APIProductService.getFeaturedProducts(
          userId,
          csrfToken
        );
        // Parse products in component (UI concern)
        const parsedProducts = parseApiProducts(rawProducts);

        if (parsedProducts && parsedProducts.length > 0) {
          // Transform the data to match the expected format for featuredProducts
          const transformedApis = parsedProducts.map((product) => ({
            productUuid: product.uuid,
            productTitle: product.title,
            body: product.description,
            imageUrl: product.image?.url || "",
            alias: product.alias,
            disable_documentation: product.disable_documentation,
            label: product.label,
          }));
          setFeaturedApis(transformedApis);
        } else {
          // Fall back to using frontPageBanners if no products
          setFeaturedApis(frontPageBanners);
        }
      } catch (error) {
        console.error("Error fetching featured APIs:", error);
        // Fall back to using frontPageBanners if API call fails
        setFeaturedApis(frontPageBanners);
      }
    };

    loadFeaturedApis();
  }, [csrfToken]);

  return (
    <div>
      <MetaData
        title="NBG"
        url={FRONTEND_ORIGIN_URL_NO_SLASH + getRouteUrl(ROUTE_PAGE_HOME)}
        description="NBG developers portal."
      />

      <FrontPage
        setManualLogOut={setManuallLogout}
        isManuallyLoggedOut={isManuallyLoggedOut}
        isLoggedIn={isLoggedIn}
        username={username}
        sampleAction={sampleAction}
        featuredProducts={
          featuredApis.length > 0 ? featuredApis : frontPageBanners
        }
        steps={hardcodedSteps}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  isLoggedIn: state.applicationUser?.isLoggedIn,
  isManuallyLoggedOut: state.applicationUser?.manuallyLoggedOut,
  frontPageBanners: parsefrontPageBanners(state.general?.frontPageBanners),
  csrfToken: state.applicationUser?.csrfToken,
  applicationUser: state.applicationUser,
});

const mapDispatchToProps = (dispatch) => ({
  setManuallLogout: (payload) => {
    dispatch(setManuallLogout(payload));
  },
});

export default withTracker(
  AuthorizationHOC(ALL_USERS)(
    connect(mapStateToProps, mapDispatchToProps)(FrontPageHOC)
  )
);
